/**
 * Auto-add Elderberry Kit when FREEKIT discount code is applied
 *
 * This script monitors cart updates and automatically adds the Elderberry Kit
 * product to the cart when the FREEKIT discount code is detected.
 */

(function() {
  'use strict';

  // Configuration - UPDATE THESE VALUES
  const CONFIG = {
    discountCode: 'FREEKIT',
    elderberryKitVariantId: 8606914216178, // Elderberry Syrup Kit variant ID
    checkoutUrlPattern: /\/checkouts\//,
  };

  // Track if we've already added the kit to prevent duplicate additions
  let elderberryKitAdded = false;

  /**
   * Check if cart has the FREEKIT discount applied
   */
  function hasFreekitDiscount(cart) {
    if (!cart || !cart.cart_level_discount_applications) {
      return false;
    }

    return cart.cart_level_discount_applications.some(discount => {
      return discount.title && discount.title.toUpperCase() === CONFIG.discountCode;
    });
  }

  /**
   * Check if Elderberry Kit is already in cart
   */
  function hasElderberryKit(cart) {
    if (!cart || !cart.items) {
      return false;
    }

    return cart.items.some(item => {
      return item.variant_id === CONFIG.elderberryKitVariantId;
    });
  }

  /**
   * Add Elderberry Kit to cart
   */
  async function addElderberryKitToCart() {
    if (!CONFIG.elderberryKitVariantId) {
      console.warn('[Auto-add Elderberry Kit] Variant ID not configured');
      return;
    }

    if (elderberryKitAdded) {
      console.log('[Auto-add Elderberry Kit] Already added in this session');
      return;
    }

    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: CONFIG.elderberryKitVariantId,
            quantity: 1,
            properties: {
              '_free_gift': 'FREEKIT Promotion'
            }
          }]
        })
      });

      if (!response.ok) {
        throw new Error(`Failed to add Elderberry Kit: ${response.status}`);
      }

      const result = await response.json();
      elderberryKitAdded = true;
      console.log('[Auto-add Elderberry Kit] Successfully added Elderberry Kit', result);

      // Publish cart update event so cart drawer refreshes
      if (window.publish && window.PUB_SUB_EVENTS) {
        fetch('/cart.js')
          .then(res => res.json())
          .then(cart => {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
              source: 'auto-add-freekit',
              cartData: cart
            });
          });
      }

    } catch (error) {
      console.error('[Auto-add Elderberry Kit] Error:', error);
    }
  }

  /**
   * Monitor checkout URL and check for discount
   */
  function monitorCheckoutForDiscount() {
    // Check if we're on a checkout page
    if (!CONFIG.checkoutUrlPattern.test(window.location.href)) {
      return;
    }

    // Parse URL for discount code
    const urlParams = new URLSearchParams(window.location.search);
    const discountParam = urlParams.get('discount');

    if (discountParam && discountParam.toUpperCase() === CONFIG.discountCode) {
      console.log('[Auto-add Elderberry Kit] FREEKIT discount detected in checkout URL');

      // Fetch current cart and check
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          if (!hasElderberryKit(cart)) {
            addElderberryKitToCart();
          }
        })
        .catch(error => console.error('[Auto-add Elderberry Kit] Error fetching cart:', error));
    }
  }

  /**
   * Subscribe to cart update events
   */
  function initializeCartMonitoring() {
    if (!window.subscribe || !window.PUB_SUB_EVENTS) {
      console.warn('[Auto-add Elderberry Kit] PubSub not available, retrying...');
      setTimeout(initializeCartMonitoring, 500);
      return;
    }

    // Subscribe to cart updates
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, async (event) => {
      const cart = event.cartData;

      if (!cart) {
        return;
      }

      console.log('[Auto-add Elderberry Kit] Cart update detected');

      // Check if FREEKIT discount is applied
      const hasFreekit = hasFreekitDiscount(cart);
      const hasKit = hasElderberryKit(cart);

      if (hasFreekit && !hasKit) {
        console.log('[Auto-add Elderberry Kit] FREEKIT discount found, adding Elderberry Kit...');
        await addElderberryKitToCart();
      } else if (hasFreekit && hasKit) {
        console.log('[Auto-add Elderberry Kit] FREEKIT discount and Elderberry Kit both present');
      }
    });

    console.log('[Auto-add Elderberry Kit] Monitoring initialized');
  }

  /**
   * Initialize on page load
   */
  function initialize() {
    console.log('[Auto-add Elderberry Kit] Script loaded');

    // Monitor checkout page for discount codes
    monitorCheckoutForDiscount();

    // Initialize cart monitoring
    initializeCartMonitoring();
  }

  // Start when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }

})();
